export default Backbone.View.extend({
  initialize(options) {
    Rover.pubSub.on('basic_filters:visibility_updated', _.bind(this.onVisiblityUpdated, this));
  },
  onVisiblityUpdated() {
    let self = this,
      $columns = this.$('.js-basic-filter-column'),
      numVisibleColumns = $columns.find('> div:visible').length;

    _.each($columns, el => {
      self.updateColumnVisibility(el, numVisibleColumns);
    });
  },
  updateColumnVisibility(el, numVisibleColumns) {
    let $el = $(el),
      widths = $el.attr('data-lg-widths') || '{}',
      newWidth = $.parseJSON(widths)[numVisibleColumns];

    if (!newWidth) {
      return;
    }

    // Remove all col-lg prefixes
    this.removeClassesWithPrefix(el, 'col-lg-');
    $el.addClass(`col-lg-${newWidth}`);
  },
  removeClassesWithPrefix(el, prefix) {
    const classes = el.className.split(' ').filter(c => c.lastIndexOf('col-lg', 0) !== 0);
    el.className = $.trim(classes.join(' '));
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/basic_filters_layout_manager.js